import React, { useState, useEffect } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Link, useNavigate, useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import CircleIcon from "@mui/icons-material/Circle";
import axios from "axios";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import FeedbackSubmission from "../ChartsFeedAndSurvey/FeedbackSubmission";
import FeedbackResponse from "../ChartsFeedAndSurvey/FeedbackResponse";
import NewPlatUsers from "../ChartsFeedAndSurvey/NewPlatUsers";
import {
  AddIcon,
  EditIcon,
  FeedbackSurveyIcon,
  SurveyIcon,
  TotalFeedbackResponses,
  TotalSurveyResponses,
} from "../../../SvgIconsData";
import ProPopup from "../../ProPopup";
import CreateFeedback from "./CreateFeedback";
import { UnoStoreHooks, UiComponents } from "@simulanisindia/ui";
import { CreateNewIcon, EditiorIcon, FeedbackdataIcon } from "../../../assets/Icons";
import { checkPermissionExist } from "../../../utils/general";
import { FEEDBACK_CREATE_PERMISSION, FEEDBACK_MANAGE_PERMISSION } from "../../../constant/permission";
import FeedbackIcon from "@mui/icons-material/Feedback";
import apiClient from "../../../apiClient";

const { useUnoSelector } = UnoStoreHooks;
const { NormalGradientButton } = UiComponents;
const Analytics = ({ analyticsData }) => {
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const [show, setShow] = useState(false);
  const [openPro, setOpenPro] = useState(false);
  const [userPlan, setUserPlan] = useState(null);
  const [feedBackList, setFeedBacks] = useState([]);
  const [invitesList, setInvitesList] = useState([]);
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const [latestFeedbacks, setLatestFeedbacks] = useState([]);
  const skeletonNumbers = [1, 2, 3, 4];
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    if (userData?.plans?.data) setUserPlan(userData.plans.data);
  }, [userData]);

  const scores = [
    { label: "Total Feedback", value: 21, svg: <FeedbackIcon /> },
    { label: "Total Survey", value: 8, svg: <FeedbackSurveyIcon /> },
    { label: "Total Feedback Responses", value: 11, svg: <TotalFeedbackResponses /> },
    { label: "Total Survey Responses", value: 1, svg: <TotalSurveyResponses /> },
  ];

  const feedbackByChannel = async (req, res) => {
    try {

      let data = await apiClient.get(`${configData.config.UNO_URL}/api/feedback/getFeedbackByChannel`)

      // const { data } = await axios.get(`${configData.config.UNO_URL}/api/feedback/getFeedbackByChannel`, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //   },
      // });

      setSkeletonLoading(false);
      setFeedBacks(data || []);
      setInvitesList(data.invites || []);
      
    } catch (error) {
      setSkeletonLoading(true);
    }
  };

  const LatestFeedbackByChannel = async () => {
    try {

      let data = await apiClient.get(`${configData.config.UNO_URL}/api/feedback/getLatestFeedbackBychannel`)

      // const { data } = await axios.get(`${configData.config.UNO_URL}/api/feedback/getLatestFeedbackBychannel`, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //   }});

      setLatestFeedbacks(data || []);

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    feedbackByChannel();
    LatestFeedbackByChannel();
  }, []);

  const handleClickEditFeedback = (uuid) => {
    navigate(`/feedback/create/${uuid}`, {
      state: { key: "analytics" },
    });
  };
  const handleClickViewFeedback = (uuid) => {
    navigate(`/feedback/feedback/detail/${uuid}`, {
      state: { key: "analytics" },
    });
  };

  return (
    <>
      <div className="feedback mt-3 pe-3">
        <div className="row ">
          <div className="mt-3 mb-2">
            <div className="score-container">
              {scores.map((score, index) => (
                <div className="score-box-conatiner">
                  <div className="score-box" key={index}>
                    <div className="session-attribute">{score.label}</div>
                    <div className="attribute-score">{score.value}</div>
                  </div>
                  <div className=" score-svg">{score.svg}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="row ">
            <div className="col-md-4 mt-3">
              <div className="card custom-chart">
                <div className="card-body pb-2">
                  <FeedbackSubmission analyticsData={analyticsData} />
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className="card mb-3 mb-md-0 custom-chart">
                <div className="card-body pb-2">
                  <FeedbackResponse analyticsData={analyticsData} />
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className="card custom-chart chart-custom">
                <div className="card-body">
                  <h6>Last event </h6>
                  <NewPlatUsers latestFeedbacks={latestFeedbacks} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row recentfeedback -mb-12">
          <div className="col-md-12 pe-4">
            <div className="graphbox overflow-hidden ">
              <div className=" d-flex title-mini">
                <h6 className="m-0">Recent feedback & survey </h6>

                {checkPermissionExist(FEEDBACK_CREATE_PERMISSION) && (
                  <NormalGradientButton icon={<CreateNewIcon />} text="Create New" onClick={handleShow} />
                )}
              </div>
              <div className="row mt-2">
                {skeletonLoading ? (
                  <>
                    {skeletonNumbers.map((index) => (
                      <div className="col-md-3 pb-2">
                        <div className="bg-light p-3 border rounded-2">
                          <h6 className="m-0">
                            <Skeleton />
                          </h6>
                          <p>
                            <Skeleton width={100} />
                          </p>
                          <div className="invites mt-2">
                            <div className="peeps" aria-label="Organised By : avish pratap">
                              <Skeleton circle width={25} height={25} />
                              <Skeleton circle width={25} height={25} />
                            </div>
                            <div className="d-flex gap-2">
                              <Skeleton circle width={25} height={25} />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  feedBackList
                    .sort()
                    .slice(0, 4)
                    .map((feedback, index) => (
                      <div className="col-md-3 pb-2">
                        <div className="white-color p-3 border rounded-2 gap-3">
                          <h6 className=" text-capitalize d-flex align-items-center justify-content-between typesder">
                            <strong>{feedback.name}</strong>
                            {feedback.publishTime === null ? (
                              <OverlayTrigger placement="top" overlay={<Tooltip>Draft</Tooltip>}>
                                <p>
                                  {/* <span style={{ color: '#ffffff' }}>
                                  <strong>

                                  </strong>
                                </span> */}
                                </p>
                              </OverlayTrigger>
                            ) : (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip>
                                    {feedback.status.charAt(0).toUpperCase() + feedback.status.slice(1).toLowerCase()}{" "}
                                  </Tooltip>
                                }
                              >
                                <p>
                                  {/* <span className={`text-${feedback.status === 'LIVE' ? 'success' : 'danger'}`}>
                                  <CircleIcon className="font-md" />
                                </span> */}
                                </p>
                              </OverlayTrigger>
                            )}
                          </h6>

                          <p className={`text-${feedback.type === "FEEDBACK" ? "success" : "danger"}`}>
                            {feedback.type.charAt(0).toUpperCase() + feedback.type.slice(1).toLowerCase()}
                          </p>

                          <div className="invites mt-2">
                            <div className="peeps" aria-label="Organised By : avish pratap">
                              {feedback.invites
                                .slice(0, 2)
                                .map(
                                  (invite, index) =>
                                    invite.avatar && (
                                      <img
                                        key={index}
                                        className="peepimg"
                                        src={invite.avatar}
                                        alt={`Avatar ${index}`}
                                      />
                                    )
                                )}

                              {feedback.invites.length > 2 && <>+{feedback.invites.length - 2} more</>}
                            </div>
                            <div className="d-flex justify-content-end gap-3 editibale-icon">
                              {checkPermissionExist(FEEDBACK_MANAGE_PERMISSION) && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>
                                      Edit{" "}
                                      <span className="text-capitalize ">
                                        {feedback.type.charAt(0).toUpperCase() + feedback.type.slice(1).toLowerCase()}
                                      </span>
                                    </Tooltip>
                                  }
                                >
                                  <span
                                    onClick={() => handleClickEditFeedback(feedback.uuid)}
                                    className="cursor-pointer actionbtnf"
                                  >
                                    <EditiorIcon />
                                  </span>
                                </OverlayTrigger>
                              )}

                              {feedback?.responses?.length > 0 ? (
                                <OverlayTrigger placement="top" overlay={<Tooltip>View Detail</Tooltip>}>
                                  <div
                                    className="cursor-pointer"
                                    onClick={() => handleClickViewFeedback(feedback.uuid)}
                                  >
                                    <VisibilityOutlinedIcon />
                                  </div>
                                </OverlayTrigger>
                              ) : (
                                <OverlayTrigger placement="top" overlay={<Tooltip>No Detail</Tooltip>}>
                                  <div className="cursor-pointer">
                                    <VisibilityOutlinedIcon />
                                  </div>
                                </OverlayTrigger>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                )}
              </div>
            </div>
          </div>
        </div>

        <CreateFeedback show={show} handleClose={handleClose} />
        <ProPopup openPro={openPro} setOpenPro={setOpenPro} />
      </div>
    </>
  );
};

export default Analytics;
